/**
 * @generated SignedSource<<3a5766fc096693caba0b50111631ad15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlightsProvider = "KIWI" | "WAAVO";
export type SmtpType = "NONE" | "SSL" | "TLS";
import { FragmentRefs } from "relay-runtime";
export type GeneralSettingsEditForm_settings$data = {
  readonly abandonedCheckoutTimeout: number | null;
  readonly adminEmailErrors: string | null;
  readonly adminEmailNewsSubscribers: string | null;
  readonly adminEmailOrders: string | null;
  readonly advancePayment: number | null;
  readonly autosaveDelay: number | null;
  readonly cancelOrdersAfterMinutes: number | null;
  readonly debugMode: boolean | null;
  readonly defaultTransferPrice: number | null;
  readonly descriptionTitle: string | null;
  readonly durationRanges: ReadonlyArray<{
    readonly end: number;
    readonly start: number;
  }> | null;
  readonly facebookAppId: string | null;
  readonly flightBookingEnabled: boolean | null;
  readonly flightsApiLimit: number | null;
  readonly flightsProvider: FlightsProvider | null;
  readonly flightsUpdaterEnabled: boolean | null;
  readonly inactiveUpdaterWarningThreshold: number | null;
  readonly infantTripPrice: number | null;
  readonly keepFlightPriceHistoryDays: number | null;
  readonly notesTitle: string | null;
  readonly orderCleanupAge: number | null;
  readonly priceChangeTreshold: number | null;
  readonly priceCheckerLimit: number | null;
  readonly profiler: boolean | null;
  readonly revalidateStaticContent: number | null;
  readonly schemaProviderDetails: {
    readonly address: string | null;
    readonly city: string | null;
    readonly country: string | null;
    readonly image: string | null;
    readonly logo: string | null;
    readonly name: string | null;
    readonly phone: string | null;
    readonly postcode: string | null;
    readonly pricerange: string | null;
  } | null;
  readonly seoHomeMetaDescription: string | null;
  readonly seoHomeTitle: string | null;
  readonly smtpEmail: string | null;
  readonly smtpName: string | null;
  readonly smtpPassword: string | null;
  readonly smtpPort: number | null;
  readonly smtpServer: string | null;
  readonly smtpType: SmtpType | null;
  readonly smtpUser: string | null;
  readonly standardMarkupAdult: number | null;
  readonly standardMarkupChild: number | null;
  readonly titleSuffix: string | null;
  readonly tripsH1: string | null;
  readonly tripsMetaDescription: string | null;
  readonly tripsMetaTitle: string | null;
  readonly updateFlightsPerMinute: number | null;
  readonly " $fragmentType": "GeneralSettingsEditForm_settings";
};
export type GeneralSettingsEditForm_settings$key = {
  readonly " $data"?: GeneralSettingsEditForm_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeneralSettingsEditForm_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeneralSettingsEditForm_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardMarkupAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardMarkupChild",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "infantTripPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advancePayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultTransferPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notesTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntRange",
      "kind": "LinkedField",
      "name": "durationRanges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revalidateStaticContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelOrdersAfterMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autosaveDelay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceCheckerLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminEmailErrors",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminEmailNewsSubscribers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminEmailOrders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "abandonedCheckoutTimeout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderCleanupAge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpServer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpPort",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpPassword",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smtpType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seoHomeTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seoHomeMetaDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleSuffix",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripsMetaTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripsMetaDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripsH1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookAppId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SchemaProviderDetails",
      "kind": "LinkedField",
      "name": "schemaProviderDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pricerange",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postcode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightsProvider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightsApiLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceChangeTreshold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightsUpdaterEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightBookingEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updateFlightsPerMinute",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "keepFlightPriceHistoryDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inactiveUpdaterWarningThreshold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "debugMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profiler",
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "0c81b83d1e6ae3d01ab531adc33f73e2";

export default node;
